import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface TreatmentsTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function TreatmentsTabContent({ patient, loading }: TreatmentsTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_treatments}</Card>;
}

export default TreatmentsTabContent;
